var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container sensory-calibration-detail" },
    [
      _c(
        "el-row",
        { staticStyle: { margin: "20px 0 20px 0" } },
        [
          _vm.action == "SP_EDIT" || _vm.action == "CQS_EDIT"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.CalibrationSave,
                      expression: "CalibrationSave",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
              )
            : _vm._e(),
          _vm.action == "CQS_EDIT"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.CalibrationCalibration,
                      expression: "CalibrationCalibration",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.calibrate()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("sensory.calibration.calibration")))]
              )
            : _vm._e(),
          _vm.action == "SP_EDIT" || _vm.action == "CQS_EDIT"
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.CalibrationSave,
                      expression: "CalibrationSave",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "sensoryCalibration" })
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
          _vm.action == "SP_EDIT" ||
          _vm.action == "CQS_EDIT" ||
          _vm.action == "SP_EDIT" ||
          _vm.action == "CQS_EDIT"
            ? [
                _c("br"),
                _c(
                  "label",
                  { staticStyle: { "font-size": "12px", color: "#F56C6C" } },
                  [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "calibration",
          attrs: {
            model: _vm.calibration,
            "label-width": "150px",
            rules: _vm.calibrationRules,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("sensory.report.serialNo") } },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.calibration.serialNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.calibration, "serialNo", $$v)
                          },
                          expression: "calibration.serialNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  attrs: {
                    span:
                      _vm.action == "SP_EDIT" || _vm.action == "SP_SUBMIT"
                        ? 16
                        : 8,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sensory.report.name"),
                        prop: "fiveBitCodeName",
                      },
                    },
                    [
                      _c("PickupFiveBitCode", {
                        attrs: {
                          disabled: _vm.disabled,
                          fiveBitCode: {
                            fiveBitCode: _vm.calibration.fiveBitCode,
                            fiveBitCodeName: _vm.calibration.fiveBitCodeName,
                          },
                          title: _vm.$t("sensory.report.name"),
                        },
                        on: { pickup: _vm.changeFiveBitCode },
                        model: {
                          value: _vm.calibration.fiveBitCodeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.calibration, "fiveBitCodeName", $$v)
                          },
                          expression: "calibration.fiveBitCodeName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.action == "CQS_EDIT" || _vm.action == "CQS_SUBMIT"
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("sensory.report.rater"),
                            prop: "rater",
                          },
                        },
                        [
                          _c(
                            "el-autocomplete",
                            {
                              staticClass: "inline-input",
                              attrs: {
                                title: _vm.calibration.rater,
                                disabled: _vm.action != "CQS_EDIT",
                                clearable: "",
                                "fetch-suggestions": _vm.raterSuggest,
                                placeholder: "请输入内容",
                              },
                              on: { select: _vm.selectQaLab },
                              model: {
                                value: _vm.calibration.rater,
                                callback: function ($$v) {
                                  _vm.$set(_vm.calibration, "rater", $$v)
                                },
                                expression: "calibration.rater",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.searchRater()
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sensory.report.rateDate"),
                        prop: "rateDate",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          disabled: _vm.disabled,
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                        },
                        model: {
                          value: _vm.calibration.rateDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.calibration, "rateDate", $$v)
                          },
                          expression: "calibration.rateDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sensory.report.rateType"),
                        prop: "rateType",
                      },
                    },
                    [
                      _c("ic-select", {
                        attrs: {
                          disabled: true,
                          table: "TT_SENSORY",
                          field: "RATE_TYPE",
                          clearable: "",
                        },
                        model: {
                          value: _vm.calibration.rateType,
                          callback: function ($$v) {
                            _vm.$set(_vm.calibration, "rateType", $$v)
                          },
                          expression: "calibration.rateType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("sensory.report.status") } },
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.calibration.statusI18n,
                          callback: function ($$v) {
                            _vm.$set(_vm.calibration, "statusI18n", $$v)
                          },
                          expression: "calibration.statusI18n",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("nav.plant"), prop: "plantNames" },
                    },
                    [
                      _c("el-input", {
                        attrs: { value: _vm.plants, disabled: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sensory.calibration.sourceSerialNo"),
                        prop: "sourceSerialNo",
                      },
                    },
                    [
                      _c("el-input", {
                        ref: "pickUpSourceInput",
                        attrs: { disabled: _vm.action != "CQS_EDIT" },
                        on: {
                          focus: function ($event) {
                            return _vm.prePickUpSource()
                          },
                        },
                        model: {
                          value: _vm.calibration.sourceSerialNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.calibration, "sourceSerialNo", $$v)
                          },
                          expression: "calibration.sourceSerialNo",
                        },
                      }),
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            visible: _vm.showPickupSourceDialg,
                            width: "80%",
                          },
                          on: {
                            close: function ($event) {
                              _vm.showPickupSourceDialg = false
                            },
                          },
                        },
                        [
                          _c("sensory-report-list", {
                            attrs: {
                              "five-bit-code-name":
                                _vm.calibration.fiveBitCodeName,
                              fiveBitCode: _vm.calibration.fiveBitCode,
                              action: "pickUp",
                            },
                            on: { pickUp: _vm.pickUpSource },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("common.remarks"),
                        prop: "remarks",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "handle-input",
                        attrs: { disabled: _vm.disabled, maxlength: "300" },
                        model: {
                          value: _vm.calibration.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.calibration, "remark", $$v)
                          },
                          expression: "calibration.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.calibration.status == "INACTIVE"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "作废原因" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: true, maxlength: "300" },
                            model: {
                              value: _vm.calibration.inactiveReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.calibration, "inactiveReason", $$v)
                              },
                              expression: "calibration.inactiveReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _vm.action == "CQS_EDIT" || _vm.action == "CQS_SUBMIT"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "cqs-email-input",
                          attrs: {
                            label: _vm.$t("sensory.calibration.cqsEmail"),
                            prop: "cqsEmail",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: _vm.action != "CQS_EDIT" },
                            model: {
                              value: _vm.calibration.cqsEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.calibration, "cqsEmail", $$v)
                              },
                              expression: "calibration.cqsEmail",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-button", {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.CalibrationSendMail,
                            expression: "CalibrationSendMail",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          icon: "el-icon-message",
                          circle: "",
                        },
                        on: { click: _vm.preSendMail },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("sensory.calibration.supSelfEvaluation"),
                name: "supSelfEvaluation",
              },
            },
            [
              _c("SupplierSelfEvaluation", {
                ref: "supplierSelfEvaluation",
                attrs: {
                  plantBatchSpList: _vm.calibration.plantBatchSpList,
                  "tt-sensory-calibration-id":
                    _vm.calibration.ttSensoryCalibrationId,
                  "five-bit-code": _vm.calibration.fiveBitCode,
                  "template-list": _vm.calibration.templateList,
                  action: _vm.action,
                  files: _vm.calibration.docList,
                  fiveBitCodeObj: _vm.fiveBitCodeObj,
                },
                on: {
                  "change-plants": _vm.changePlants,
                  "update:plantBatchSpList": function ($event) {
                    return _vm.$set(_vm.calibration, "plantBatchSpList", $event)
                  },
                  "update:plant-batch-sp-list": function ($event) {
                    return _vm.$set(_vm.calibration, "plantBatchSpList", $event)
                  },
                  "update:files": function ($event) {
                    return _vm.$set(_vm.calibration, "docList", $event)
                  },
                },
              }),
            ],
            1
          ),
          (_vm.emplFlag == "SUP" && _vm.calibration.status == "CQS_SUBMIT") ||
          _vm.emplFlag == "MCD"
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("sensory.calibration.CQSEvaluation"),
                    name: "CQSEvaluation",
                  },
                },
                [
                  _c("CQSEvaluation", {
                    ref: "CQSEvaluation",
                    attrs: {
                      "plant-batch-cqs-list": _vm.calibration.plantBatchCqsList,
                      action: _vm.action,
                      "template-list": _vm.calibration.templateList,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          (_vm.emplFlag == "SUP" && _vm.calibration.status == "CQS_SUBMIT") ||
          _vm.emplFlag == "MCD"
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("sensory.calibration.calibrationAnalysis"),
                    name: "calibrationAnalysis",
                  },
                },
                [
                  _c("AnalysisDetails", {
                    attrs: { analysisDetails: _vm.calibration.analysisDetails },
                  }),
                ],
                1
              )
            : _vm._e(),
          (_vm.emplFlag == "SUP" && _vm.calibration.status == "CQS_SUBMIT") ||
          _vm.emplFlag == "MCD"
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("sensory.calibration.userCalibrationInfo"),
                    name: "userCalibrationInfo",
                  },
                },
                [
                  _c("PersonnelCalibration", {
                    attrs: {
                      "personnel-calibration":
                        _vm.calibration.personnelCalibration,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showRaterDialog,
            "append-to-body": "",
            width: "80%",
            title: "评估人选择器",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRaterDialog = $event
            },
          },
        },
        [
          _c("pickupUser", {
            attrs: { multi: true },
            on: { input: _vm.selectRater },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSendMailDialog,
            title: _vm.$t("sensory.calibration.sendEmail"),
          },
          on: {
            close: function ($event) {
              _vm.showSendMailDialog = false
            },
          },
        },
        [
          _c(
            "el-container",
            [
              _c(
                "el-form",
                {
                  ref: "email",
                  staticStyle: { width: "100%" },
                  attrs: {
                    "label-width": "180px",
                    rules: _vm.sendMailRules,
                    "label-position": "right",
                    "label-suffix": ":",
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { "margin-bottom": "20px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveMail("save")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.saveMail("submit")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.send")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "to",
                            label: _vm.$t("sensory.calibration.emailReceivers"),
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.email.to,
                              callback: function ($$v) {
                                _vm.$set(_vm.email, "to", $$v)
                              },
                              expression: "email.to",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("sensory.calibration.emailTitle"),
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.email.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.email, "title", $$v)
                              },
                              expression: "email.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("sensory.calibration.emailContent"),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: "5" },
                            model: {
                              value: _vm.email.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.email, "content", $$v)
                              },
                              expression: "email.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("FileUpload", {
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      "biz-id": _vm.calibration.ttSensoryCalibrationId,
                      value: _vm.calibration.mailDocList,
                      "rec-type": "SENSORY_CALIBRATION",
                      seq: "MAIL",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }